import {isAndroid} from './lib';
import OS from '../tablet/OS';

export default class Sound {
    constructor (name, time) {
        if (isAndroid) {
            this.url = name;
            this.soundPlayId = null;
        } else {
            this.name = name;
            this.time = time;
            this.playing = false;
        }
    }

    play () {
        if (isAndroid) {
            if (this.soundPlayId) {
                this.stop();
            }
            this.soundPlayId = AndroidInterface.audio_play(this.url, 1.0);
        } else {
            if (this.playing) {
                this.stop();
            }
            OS.playSound(this.name);
            this.playing = true;
        }
    }

    done () {
        if (isAndroid) {
            // Fix Issue #44: Check if sound has finished playing
            if (this.soundPlayId == null) {
                return true; // No sound to play
            }
            
            // AndroidInterface.audio_isplaying returns a JSON string like:
            // '{"status":"ok","result":"program_sound_played","isPlaying":true}' or 
            // '{"status":"ok","result":"program_sound_stopped","isPlaying":false}'
            try {
                // Fix Issue #44: Set guard flag to prevent Bug #16 Fix recursion
                AndroidInterface.audio_isplaying._checkingCompletion = true;
                const playStatusJson = AndroidInterface.audio_isplaying(this.soundPlayId);
                AndroidInterface.audio_isplaying._checkingCompletion = false;
                
                // Handle both JSON string and direct object responses for compatibility
                let playStatus;
                if (typeof playStatusJson === 'string') {
                    playStatus = JSON.parse(playStatusJson);
                } else if (typeof playStatusJson === 'boolean') {
                    return !playStatusJson; // Legacy boolean response
                } else {
                    playStatus = playStatusJson; // Already an object
                }
                
                if (playStatus && playStatus.status === 'ok') {
                    // Sound is done if result indicates it's stopped or completed
                    const isDone = playStatus.result === 'program_sound_stopped' || 
                                   playStatus.result === 'program_sound_complete' ||
                                   playStatus.result === 'program_sound_finished' ||
                                   playStatus.isPlaying === false;
                    
                    return isDone;
                }
                
                // If we can't determine status, assume it's still playing for safety
                return false;
            } catch (e) {
                // Fix Issue #44: Ensure guard flag is cleared even on error
                AndroidInterface.audio_isplaying._checkingCompletion = false;
                // Fallback: assume sound is done to prevent infinite loop
                return true;
            }
        } else {
            return (!this.playing);
        }
    }

    clear () {
        if (isAndroid) {
            this.soundPlayId = null;
        } else {
            this.playing = false;
        }
    }

    stop () {
        if (isAndroid) {
            if (this.soundPlayId) {
                AndroidInterface.audio_stop(this.soundPlayId);
            }
            this.soundPlayId = null;
        } else {
            OS.stopSound(this.name);
            this.playing = false;
        }
    }
}
